import { APIError } from '../../../../../utils'

export const isFecImportConflictError = (error: unknown): error is APIError =>
  error instanceof APIError && error.statusCode === 409
